// extracted by mini-css-extract-plugin
export var smallSpinner = "_qg-0";